import request from '@/utils/request'

// 分页查询房源信息
export function getPageList(params) {
  return request({
    url: '/hrApi/house',
    method: 'get',
    params: params
  })
}

// 获取房源列表
export function getList(params) {
  return request({
    url: '/hrApi/house/list',
    method: 'get',
    params: params
  })
}

// 新增或编辑房源
export function saveOrUpdateData(data) {
  return request({
    url: '/hrApi/house',
    method: 'post',
    data: data
  })
}

// 删除房源
export function deleteData(id) {
  return request({
    url: '/hrApi/house/' + id,
    method: 'delete'
  })
}

// 结算
export function settlement(params) {
  return request({
    url: '/hrApi/house/settlement',
    method: 'get',
    params: params
  })
}

// 结算
export function getHomeStatisticData(params) {
  return request({
    url: '/hrApi/house/statistics',
    method: 'get',
    params: params
  })
}

// 导出
export function exportData(params) {
  return request({
    url: '/hrApi/house/export',
    method: 'get',
    params: params,
    responseType: 'blob'
  })
}



// WEBPACK FOOTER //
// ./src/api/house.js